import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { BaseDialog } from '@metarouter-private/mr-mui';
import { useUpdatePlaybookDisabled } from '@ion/api';

import DisableRevisionModalContent from './DisableRevisionModalContent';
import DisableRevisionModalActions from './DisableRevisionModalActions';

const DIALOG_PROPS = { maxWidth: 'sm', fullWidth: true };

export default function DisableRevisionModal({ open, onClose, playbook }) {
  const [disabledNote, setDisabledNote] = useState('');
  const [updatePlaybookDisabled, { loading }] = useUpdatePlaybookDisabled({ onCompleted: onClose });

  useEffect(() => {
    if (!open) setDisabledNote('');
  }, [open]);

  const handleDisable = () => {
    updatePlaybookDisabled({
      playbookId: playbook.id,
      disabled: true,
      disabledNote: disabledNote.trim() || null,
    });
  };

  return (
    <BaseDialog
      DialogProps={{ ...DIALOG_PROPS, open, onClose }}
      title="Disable Revision"
      content={<DisableRevisionModalContent disabledNote={disabledNote} onChange={setDisabledNote} />}
      actions={<DisableRevisionModalActions onCancel={onClose} onDisable={handleDisable} loading={loading} />}
    />
  );
}

DisableRevisionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  playbook: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};
